export const ENTER_PROMO = "enter_promo";
export const ENTER_PROMO_FAIL = "enter_promo_fail";
export const ENTER_PROMO_SUCCESS = "enter_promo_success";
export const RESET_PROMO = "reset_promo";
export const PROMO_FIELD_CHANGE = "promo_field_change";
